import '../css/footer.css';

export default function Footer() {
    return (
        < div className="footer" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="https://maps.app.goo.gl/BoerC89tM6vXbqNk7" target="_blank" rel="noopener noreferrer"><p><i className="fa fa-map-marker-alt"></i>በቦሌ ደብረ ሳሌም ቅዱስ ዮሐንስ መድኃኔዓለም ቤተክርስቲያን ፣ አቡነ አረጋዊ ቤተክርስቲያን ፣ በኢ/ኦ ተዋህዶ ቤ/ክ</p></a>
                            <a href="tel:+251-9385223242"><p><i className="fa fa-phone"></i>+251-9385223242</p></a>
                            <a href="mailto:mahabreyohannes@gmail.com"><p><i className="fa fa-envelope"></i>mahabreyohannes@gmail.com</p></a>
                            <div className="footer-social">
                                <a className="btn btn-custom" href="https://twitter.com/vit_socials"><i className="fab fa-x-twitter"></i></a>
                                <a className="btn btn-custom" href="https://www.facebook.com/vitsocials"><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-custom" href="https://www.instagram.com/vitsocials/"><i className="fab fa-instagram"></i></a>
                                <a className="btn btn-custom" href="https://www.youtube.com/channel/UCJnaNm8Ns08rUIhsdFM2fhA"><i className="fab fa-youtube"></i></a>
                                <a className="btn btn-custom" href="https://www.linkedin.com/company/vit-social-welfare-development/"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>ተወዳጅ ሊንኮች</h2>
                            <a href="/about">ስለ እኛ</a>
                            <a href="/contact">ከእኛ ጋር ይገናኙ</a>
                            <a href="/event">ተወዳጅ መንስኤዎች</a>
                            <a href="/event">ወደፊት የሚፈጸሙ ክንውኖች</a>
                            <a href="#">የቅርብ ጊዜ ጦማር</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>ጠቃሚ አገናኞች</h2>
                            <a href="#">የአጠቃቀም ውል</a>
                            <a href="#">የግላዊነት ፖሊሲ</a>
                            <a href="#">ኩኪዎች</a>
                            <a href="#">እገዛ</a>
                            <a href="#">በተደጋጋሚ የሚጠየቁ ጥያቄዎች</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-newsletter">
                            <h2>ጋዜጣ</h2>
                            <form name='NewsLetter'>
                                <input name='subscribe' className="form-control" placeholder="ኢሜል" autoComplete='email' required/>
                                <button className="btn btn-custom">አስገባ</button>
                                <h6>አይጨነቁ፣ አይፈለጌ መልዕክት አንሰራም!</h6>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; 2025.  <a href="#">ማህበረ ዮሃንስ
                        </a>- ሁሉም መብቶች የተጠበቁ ናቸው።</p>
                    </div>
                    <div className="col-md-6">
                        <p>Designed By <a href="https://www.linkedin.com/in/bhavesh-patil-92b7aa22a">YOD business Solution</a></p>
                    </div>
                </div>
            </div>
        </ div>
    );
}